import React from "react"
import { Link } from "react-router-dom"
import { studentPracticePaperHref } from "../../../../component/student/config/studentNavItems"
import { PAPER_STATUS_LABEL } from "../../PracticePapers/utils/paperStatus"
import type { DashboardGoal, DashboardGoalPaper } from "../types"
import { formatGoalDueLabel } from "../utils/formatGoalDueLabel"
import "./DashboardGoalCard.style.scss"

interface DashboardGoalCardProps {
  goal: DashboardGoal
  onAbandonedPaper: (paper: DashboardGoalPaper) => void
}

const dueChipLabel = (goal: DashboardGoal) => {
  const dateLabel = formatGoalDueLabel(goal.dueDate)
  if (goal.status === "completed") return "Done"
  if (goal.status === "overdue") {
    return dateLabel ? `Overdue · ${dateLabel}` : "Overdue"
  }
  return dateLabel ? `Due ${dateLabel}` : "Due"
}

const paperStatusLabel = (status: string) => {
  if (status === "unavailable") return "Unavailable"
  return (
    PAPER_STATUS_LABEL[status as keyof typeof PAPER_STATUS_LABEL] || status
  )
}

const DashboardGoalCard = ({
  goal,
  onAbandonedPaper,
}: DashboardGoalCardProps) => (
  <article className={`dashboard-goal-card is-${goal.status}`}>
    <div className="dashboard-goal-card__meta">
      <span className="dashboard-goal-card__subject">{goal.subject}</span>
      <span className={`dashboard-goal-card__due is-${goal.status}`}>
        {dueChipLabel(goal)}
      </span>
    </div>
    <h4>{goal.title || goal.task}</h4>
    <p className="dashboard-goal-card__target">{goal.target}</p>
    {goal.papers.length > 0 ? (
      <ul className="dashboard-goal-card__papers">
        {goal.papers.map((paper) => {
          const label = `${paper.title} · ${paperStatusLabel(paper.status)}`
          if (paper.status === "unavailable") {
            return <li key={paper.id}>{label}</li>
          }
          if (paper.status === "abandoned") {
            return (
              <li key={paper.id}>
                <button
                  type="button"
                  className="dashboard-goal-card__paper-btn"
                  onClick={() => onAbandonedPaper(paper)}
                >
                  {label}
                </button>
              </li>
            )
          }
          return (
            <li key={paper.id}>
              <Link to={studentPracticePaperHref(paper.id)}>{label}</Link>
            </li>
          )
        })}
      </ul>
    ) : null}
    <div className="dashboard-goal-card__progress">
      <div className="dashboard-goal-card__track">
        <div style={{ width: `${goal.progressPercent}%` }} />
      </div>
      <span>
        {goal.currentProgress} of {goal.targetCount || 0} complete ·{" "}
        {goal.progressPercent}%
      </span>
    </div>
  </article>
)

export default DashboardGoalCard
